import React from 'react';

import PropTypes from 'prop-types';
import pt from 'date-fns/locale/pt';
import { format, parseISO } from 'date-fns';

import { Grid } from './styles';

export default function Procuracoes({ dados }) {
  const data = dados.map(item => ({
    ...item,
    dateFormatted: item.data_protocolo
      ? format(parseISO(item.data_protocolo), "dd 'de' MMMM' de' yyyy", {
          locale: pt,
        })
      : null,
    dateVigencia: item.vigencia
      ? format(parseISO(item.vigencia), "dd 'de' MMMM' de' yyyy", {
          locale: pt,
        })
      : null,
  }));

  return (
    <Grid>
      {data.map(item => (
        <div key={item.id} className="content">
          <div className="tabelas">
            <div>
              <strong>Órgão: </strong>
              {item.orgao}
            </div>
            <div>
              <strong>Tipo Certificado: </strong>
              {item.certificado}
            </div>
            <div>
              <strong>Titular Certificado: </strong> {item.titular}
            </div>
          </div>
          <div className="tabelas">
            <div>
              <strong>Outorgado: </strong>
              {item.outorgado}
            </div>
            <div>
              <strong>Fim Vigência: </strong>
              {item.dateVigencia}
            </div>
            <div>
              <strong>Data limite protocolado pela Secran: </strong>
              {item.dateFormatted}
            </div>
          </div>
        </div>
      ))}
    </Grid>
  );
}

Procuracoes.propTypes = {
  dados: PropTypes.array, //eslint-disable-line
};

Procuracoes.defaultProps = {
  dados: [],
};
